import { convertLabelMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.MixMaximumParticleSize`]: 'Mix Maximum Particle Size',
      [`${prefix}.Preparation.SieveSizeId`]: 'Mix Maximum Particle Size',
      [`${prefix}.Preparation.SampleWarming`]: 'Sample needs warming to loosen',
      [`${prefix}.Preparation.ContainsMoistureOrVolatileOils`]: 'Sample contains moisture or volatile oils',

      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DateTimePlacedInOvenLocal`]: 'Date and Time in Oven',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]:
        'Date and Time Out of Oven',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]:
        'Tare & Dry Mass',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerMass`]: 'Drying Tare Mass',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilAndContainerMass`]:
        'Tare and Portion Wet Mass',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilMass`]: 'Test Portion Wet Mass',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.Oven`]: 'Oven',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.DryingTemperature`]: 'Oven Temperature',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.Balance`]: 'Balance',
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.DryMassBalance`]: 'Dry Mass Balance',

      [`${prefix}.InitialDrying.TestPortionDryMass`]: 'Test Portion Dry Mass',
      [`${prefix}.InitialDrying.MoistureVolatileContent`]: 'Moisture and Volatile Content',

      [`${prefix}.Measurements.BalanceBinderExtraction`]: `Balance`,
      [`${prefix}.Measurements.BalanceBinderSeparation`]: `Balance`,
      [`${prefix}.Measurements.BitumenCentrifugeExtractor`]: `Centrifuge Extractor`,
      [`${prefix}.Measurements.Centrifuge`]: `Centrifuge`,
      [`${prefix}.Measurements.TestTakenFromInitialDrying`]: `Entire test portion taken from initial drying`,
      [`${prefix}.Measurements.FlaskAndStopperMass`]: `Flask and Stopper Mass`,
      [`${prefix}.Measurements.FilterBowlMass`]: `Filter Bowl Mass`,
      [`${prefix}.Measurements.FilterBowlTestPortionMass`]: `Filter Bowl & Test Portion Mass`,
      [`${prefix}.Measurements.TestPortionMass`]: `Test Portion Mass`,
      [`${prefix}.Measurements.FlaskStopperSolutionMass`]: `Flask, Stopper and Solution Mass`,
      [`${prefix}.Measurements.SolutionMass`]: `Solution Mass`,

      [`${prefix}.Measurements.Trials.ContainerAndLidMass`]: `Container and Lid Mass`,
      [`${prefix}.Measurements.Trials.ContainerLidAndLiquidMass`]: `Container, Lid and Liquid Mass`,
      [`${prefix}.Measurements.Trials.ContainerLidAndResidueMass`]: `Container, Lid and Residue Mass`,
      [`${prefix}.Measurements.Trials.MassOfBinder`]: `Mass of Binder`,
      [`${prefix}.Measurements.Trials.BinderContentPercentage`]: `Binder Content`,
      [`${prefix}.Measurements.Trials.ExcludedTrial`]: `Exclude Trial`,

      [`${prefix}.Results.AggregateMass`]: `Aggregate Mass`,
      [`${prefix}.Results.BinderContentFinal`]: `Binder Content`,
    })
  );

export default getLabelConfig;
